import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { inject } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private router = inject(Router)

  canActivate(): boolean {
    const isAuthenticated = sessionStorage.getItem('authToken')

    if (!isAuthenticated) {
      this.router.navigate(['login'])
      return false
    }

    return true
  }
}

export class authGuard {}
